import {
  Dropdown,
  Icon,
  IDropdownOption,
  ISelectableOption,
} from '@fluentui/react';
import React, {useMemo} from 'react';
import styled from 'styled-components';
import {textColorTheme} from '../../styles';
import {Sorter} from '../../types/Sorter';
import {SortOrder} from '../../types/SortOrder';

export type OnChangeSorterFn = (sorter: Sorter, current: SortOrder) => void;

type Props = {
  currentSortOrder: SortOrder;
  sorters: Sorter[];
  onChange: OnChangeSorterFn;
};

export function SorterChanger(props: Props): JSX.Element | null {
  const sorterMap = useSorterMap(props.sorters);

  const options = props.sorters.map((sorter: Sorter) => {
    return {
      key: sorter.id,
      text: String(sorter.label),
      selected: sorter.id === props.currentSortOrder.sort,
    };
  });

  const styles = {
    root: {
      width: '12em',
    },
  };

  return (
    <Container>
      <Label>並び順</Label>
      <Dropdown
        options={options}
        notifyOnReselect={true}
        styles={styles}
        onRenderOption={(opt) => {
          return opt ? renderOption(opt, props.currentSortOrder) : null;
        }}
        onRenderTitle={(opts) => {
          return opts && opts[0]
            ? renderTitle(opts[0], props.currentSortOrder)
            : null;
        }}
        onChange={(e, opt) => {
          if (opt) {
            const sorter = sorterMap[opt.key as string];

            if (sorter) {
              props.onChange(sorter, props.currentSortOrder);
            }
          }
        }}
      />
    </Container>
  );
}

type SorterMap = {[key: string]: Sorter};

function useSorterMap(sorters: Sorter[]): SorterMap {
  return useMemo((): SorterMap => {
    const m: SorterMap = {};

    for (let sorter of sorters) {
      m[sorter.id] = sorter;
    }

    return m;
  }, [sorters]);
}

function renderOption(opt: ISelectableOption, current: SortOrder) {
  return (
    <Option>
      {renderIcon(opt.key as string, current)}
      {opt.text}
    </Option>
  );
}

function renderIcon(id: string, current: SortOrder) {
  if (id !== current.sort) {
    return <ArrowIcon iconName={''} />;
  }

  const iconName = current.order === 'desc' ? 'SortUp' : 'SortDown';
  return <ArrowIcon iconName={iconName} />;
}

function renderTitle(opt: IDropdownOption, current: SortOrder) {
  return (
    <Option>
      {renderIcon(opt.key as string, current)}
      {opt.text}
    </Option>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Label = styled.div`
  margin-right: 0.5em;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
`;

const ArrowIcon = styled(Icon)`
  color: ${textColorTheme};
  margin-right: 0.3rem;
`;
